/**
 * A site-relative path made absolute against a brand's root — for the head
 * tags that are read off the page by something with no page to resolve
 * against (og:image). An already-absolute URL (R2, a CDN) passes through.
 */
export function absoluteUrl(url: string, root: string): string {
  if (/^https?:\/\//i.test(url)) return url
  return `${root.replace(/\/$/, "")}${url.startsWith("/") ? "" : "/"}${url}`
}
